import React, { useRef } from 'react';
import styled from 'styled-components';

import { useModal } from '../../../Providers/ModalContext';
import Modal from '../../../Global/Modal';
import RichText from '../../../Global/RichText';
import Carousel from '../../../Global/Carousel/Carousel';

import CloseIcon from '../../../../Images/icons/close-icon.png';
import PortBg from '../../../../Images/background/bg_portfolio-films.png';
import LogoFilms from '../../../../Images/logos/logo_films_nav.png';

import {
  TITLE_PORT,
  PORT_FILMS,
  slides,
} from '../../../../utils/ES/Modals/filmsPortfolio';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalContent = styled.div`
  width: 100%;
  position: relative;
  padding: 0px 70px;
  display: flex;
  align-items: flex-start;

  flex-direction: column;
  gap: 1rem;

  @media (max-width: ${breakpoints.mobile}) {
    gap: 3rem;
  }

  .align {
    text-align: center;
    margin: 0 auto;

    @media (max-width: ${breakpoints.mobile}) {
      text-align: left;
    }
  }
`;

const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 3.375rem;

  h2 {
    text-transform: uppercase;
  }
`;

const LogoContent = styled.div`
  display: block;
  max-width: 276px;
  width: 100%;
  padding: 15px;
  position: relative;

  img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-out;

    &:hover {
      filter: drop-shadow(0px 0px 20px rgba(147, 206, 255, 1));
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 93px;
    background: #fff;

    top: 0;
    bottom: 0;

    margin: auto;
    right: -10%;
  }
`;

const ModalPortfolioFilms = () => {
  const { closeModal, modalData } = useModal();

  const initialIndex = slides.findIndex(
    (slide) => slide.id === modalData?.item
  );
  const safeInitialIndex = initialIndex >= 0 ? initialIndex : 0;

  return (
    <>
      <Modal id="portfolio-films" bgImg={PortBg}>
        <CloseContainer>
          <CloseButton
            onClick={closeModal}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>
        <ModalContent>
          <TitleContent>
            <LogoContent>
              <img
                src={LogoFilms}
                alt="Kuter Films Reel"
                onClick={closeModal}
                aria-label="Close modal"
              />
            </LogoContent>
            <RichText dataText={TITLE_PORT} />
          </TitleContent>
          <Carousel
            slides={slides}
            initialIndex={safeInitialIndex}
            textTrailer={'Tráiler'}
          />
          <RichText className="align" dataText={PORT_FILMS} />
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalPortfolioFilms;
